module.exports = __webpack_public_path__ + "static/img/50.590cbea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/50.gif
// module id = 2MbA
// module chunks = 0